/* eslint-disable jsx-a11y/label-has-associated-control */
import { components } from 'react-select';
import makeAnimated from 'react-select/animated';
import MySelect from './MySelect';

const options = [
  { value: 1, label: 'Bénéficiaires non-rattachés' },
  { value: 2, label: 'ORIENTACTION uniquement' },
  { value: 4, label: 'Espaces entreprises spécifiques' },
];

const Option = (props: any) => {
  const { label, isSelected } = props;
  return (
    <div>
      <components.Option {...props}>
        <input type="checkbox" checked={isSelected} onChange={() => null} /> <label>{label}</label>
      </components.Option>
    </div>
  );
};

const allOption = {
  label: 'Autorisé à tous',
  value: 0,
};

const ValueContainer = ({ children, ...props }: any) => {
  const currentValues = props.getValue();
  let toBeRendered = children;
  if (currentValues.some((val: any) => val.value === allOption.value)) {
    toBeRendered = [[children[0][0]], children[1]];
  }

  return <components.ValueContainer {...props}>{toBeRendered}</components.ValueContainer>;
};

const MultiValue = (props: any) => {
  const { data } = props;
  let labelToBeDisplayed = `${data.label}, `;
  if (data.value === allOption.value) {
    labelToBeDisplayed = 'Autorisé à tous';
  }
  return (
    <components.MultiValue {...props}>
      <span>{labelToBeDisplayed}</span>
    </components.MultiValue>
  );
};

const animatedComponents = makeAnimated();

const PermissionSelect = (props: any) => {
  const { updateTest, test } = props;
  const handleChange = (selected: any) => {
    updateTest({ ...test, visibilityPermission: selected });
  };
  return (
    <MySelect
      options={options}
      allOption={allOption}
      isMulti={true}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      components={{
        Option,
        MultiValue,
        ValueContainer,
        animatedComponents,
      }}
      onChange={handleChange}
      allowSelectAll={true}
      value={test?.visibilityPermission}
      defaultValue={test?.visibilityPermission}
      hasError={!!test?.manageError?.visibilityPermission}
    />
  );
};

export default PermissionSelect;
